import * as Vuex from 'vuex';
import { wmct } from '@/store/wmct';
import { State } from '@/store/state';
import createPersistedState from 'vuex-persistedstate';
import { CourseEntry, AssessmentEntry } from '@/models';

export const createStore = () => new Vuex.Store<State>({
	strict: process.env.NODE_ENV !== 'production',
	modules: {
		wmct,
	},
	// plugins: [createPersistedState()],
});
